import { useRouter } from 'expo-router'
import { KeyboardAvoidingView, Platform } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { Button } from '@/src/elements/button/default'
import { Stack } from '@/src/elements/navigation/Stack'
import { OtpAuthenticationProvider } from '@/src/features/auth/ui/context/OtpAuthenticationContext'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

export default function AuthLayout() {
  const router = useRouter()
  const { t } = useTranslate()

  return (
    <SafeAreaView className="flex-1 web:mb-8">
      <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : 'height'} className="flex-1">
        <OtpAuthenticationProvider>
          <Stack
            screenOptions={{
              animation: 'ios_from_right',
              keyboardHandlingEnabled: true,
              headerShown: true,
              headerTransparent: true,
              headerTitle: '',
              headerShadowVisible: false,
              headerLeft: () => (
                <Button
                  testID={TEST_ID.HEADER.BACK_BUTTON}
                  variant="light"
                  colors="primary"
                  contrast="high"
                  startIcon={ICON.ARROW_LEFT}
                  isIconOnly
                  size="sm"
                  aria-label={t('word.previous')}
                  onPress={router.back}
                />
              ),
            }}
          />
        </OtpAuthenticationProvider>
      </KeyboardAvoidingView>
    </SafeAreaView>
  )
}
